import { useRoutes } from "react-router-dom";
import FrontRoutes from "./FrontRoutes";
import LoginRoutes from "./LoginRoutes";
import MainRoutes from "./MainRoutes";
import NotFound from "../../components/NotFound";
 
const ThemeRoutes = () => {
  const routing = useRoutes([
    FrontRoutes,
    LoginRoutes,
    MainRoutes,
    { path: "*", element: <NotFound /> },
  ]);
 
  return routing;
};
 
export default ThemeRoutes;